/*
 *
 * VerifyOtp
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 23-Apr-2025
*/

import VerifyOtp from './VerifyOtpContainer'

export default VerifyOtp
